import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "../../../assets/styleuser.css"
import Logo from "../../../assets/img/logo4.jpg"
import api from "../../../services/api"
import {logout} from "../../../services/auth";


class IndexAdmin extends Component {


  state ={
    response:[],
    logout:false
  }
  
    async componentDidMount(){
  
      const response = await api.post("/user/details");
      this.setState({
        response:response.data.success,
      })
  
  
    }

    async shouldComponentUpdate(nextProps, nextState){

      if(nextState.logout==true){
        logout();
        this.props.history.push("/");
  
      }
      return true;
    }

  render() {
    return (
      <React.Fragment>

<div class="vertical-nav bg-white" id="sidebar">
<img src={Logo} alt="..." width="267" class="mr-4 img-thumbnail" />
  <br></br>
  <br></br>
  <center><h6 class="text-black-50">{this.state.response.name}</h6></center>
  <p class="text-gray font-weight-bold text-uppercase px-3 small pb-4 mb-0">Principal</p>

  <ul class="nav flex-column bg-white mb-0">
    <li class="nav-item">
      <a href="/user" class="nav-link text-dark font-italic" id="iniciomenu">
                <i class="fa fa-th-large mr-3 text-primary fa-fw"></i>
                Inicio
            </a>
    </li>
    <li class="nav-item">
      <a href="/user/cursos" class="nav-link text-dark font-italic" id="cursosmenu">
                <i class="fa fa-address-card mr-3 text-primary fa-fw"></i>
                Matriculas
            </a>
    </li>
    <li class="nav-item">
      <a href="/user/faturas" class="nav-link text-dark font-italic" id="faturamenu">
                <i class="fa fa-cubes mr-3 text-primary fa-fw"></i>
                Mensalidades
            </a>
    </li>
    <li class="nav-item">
      <a href="/pos-graduacao" target="_blank" class="nav-link text-dark font-italic" id="cursostargetmenu">
                <i class="fa fa-cubes mr-3 text-primary fa-fw"></i>
                Cursos Disponiveis
            </a>
    </li>

    <li class="nav-item">
      <a onClick={e => this.setState({ logout: true} )} href="#" class="nav-link text-dark font-italic">
                <i class="fa fa-cubes mr-3 text-primary fa-fw"></i>
                Sair
            </a>
    </li>
  </ul>
<br></br>

  <p class="text-gray font-weight-bold text-uppercase px-3 small pb-4 mb-0">Dados Pessoais</p>
  <ul class="nav flex-column bg-white mb-0">
    <li class="nav-item">
      <a href="/user/meus_dados" class="nav-link text-dark font-italic" id="meusdadosmenu">
                <i class="fa fa-th-large mr-3 text-primary fa-fw"></i>
                Meus Dados
            </a>
    </li>
  </ul>
  
  
</div>



      </React.Fragment>
       
    );
  }
}

export default withRouter(IndexAdmin);


// WEBPACK FOOTER //
// ./src/pages/User/content/header.js